import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recommended-app-slide',
  templateUrl: './recommended-app-slide.component.html',
  styleUrl: './recommended-app-slide.component.scss'
})
export class RecommendedAppSlideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
